const dataIt = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "");

export function Doc30Badge({ im, testid }) {
  if (!im?.doc30_scadenza || !(im.doc30_mancanti || []).length) return null;
  const tip = `Mancano: ${im.doc30_mancanti.join(", ")}`;
  return im.doc30_scaduti
    ? <span data-testid={testid} title={tip} className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold uppercase bg-red-600 text-white whitespace-nowrap">Documenti scaduti</span>
    : <span data-testid={testid} title={tip} className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold bg-amber-100 text-amber-800 border border-amber-300 whitespace-nowrap">Documenti da completare entro il {dataIt(im.doc30_scadenza)}</span>;
}

export { dataIt };
